import * as administrators from './modules/administrators'
import * as mainParticipants from './modules/mainParticipants'
import * as myApplication from './modules/myApplication'
import * as myCenter from './modules/myCenter'
import * as refereeManagement from './modules/refereeManagement'
import * as reviewExperts from './modules/reviewExperts'
import * as modifyingInformation from './modules/modifyingInformation'


export default {
    administrators,
    mainParticipants,
    myApplication,
    myCenter,
    refereeManagement,
    reviewExperts,
    modifyingInformation
}